import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { INSERT_UPDATE_GUIDELINE_ACTION, GET_GUIDELINE_FILE_ACTION, getGuidelineFileUrl, insertUpdateGuidelineUrl, headers } from "../../utils/constants"
import moment from 'moment';

export const insert_update_guideline_action = (GuidelineID,fileName, filePath, fileType, existFilePath,fileName2, filePath2, fileType2, existFilePath2) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
            GuidelineID: GuidelineID,
            fileName: fileName,
            filePath: filePath,
            fileType: fileType,
            existFilePath:existFilePath,
            fileName2: fileName2,
            filePath2: filePath2,
            fileType2: fileType2,
            existFilePath2:existFilePath2
        };
        const res = await axiosPost(insertUpdateGuidelineUrl, mapdata, headers);
        dispatch({
            type: INSERT_UPDATE_GUIDELINE_ACTION,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_guideline_file_action = () => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
        };
        const res = await axiosGet(getGuidelineFileUrl, mapdata, headers);
        dispatch({
            type: GET_GUIDELINE_FILE_ACTION,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};